import TradingOffersList from 'modules/trading/pages/TradingOffersList';
import { TradingOfferType } from 'types/TradingOffer';
import { TradingOffersListProvider } from '../pages/TradingOffersList/context/TradingOffersListContext';

const TradingOffersListContainer = () => (
  <TradingOffersListProvider>
    <TradingOffersList tradingOfferType={TradingOfferType.BUY} />
  </TradingOffersListProvider>
);

export default TradingOffersListContainer;
